import { FC } from 'react';
import { SnoozeIcon } from '../../icons';
import { ContentContainer } from './ContentContainer';
import { styled } from '@mui/material';
import { MainButton } from '../MainButton';
import { ButtonName, ESendLinkModal } from '../../constants';

const StyledIcon = styled(SnoozeIcon)(({ theme }) => ({
  width: theme.spacing(20),
  height: theme.spacing(15),
}));

type ExpiredLinkProps = { close: () => void };
export const ExpiredLink: FC<ExpiredLinkProps> = ({ close }) => {
  return (
    <ContentContainer>
      <StyledIcon />
      <MainButton
        onClick={close}
        variant="contained"
        fullWidth
        buttonName={ButtonName.CloseLinkModal}
      >
        {ESendLinkModal.BackToMainScreen}
      </MainButton>
    </ContentContainer>
  );
};
